module.exports = __webpack_public_path__ + "static/p_3-4e8e74975a1e57131d9136c31609f68d.png";